import { render } from "./StudentRegistrationReport.vue?vue&type=template&id=2c7c3535&scoped=true"
import script from "./StudentRegistrationReport.vue?vue&type=script&lang=js"
export * from "./StudentRegistrationReport.vue?vue&type=script&lang=js"

import "./StudentRegistrationReport.vue?vue&type=style&index=0&id=2c7c3535&scoped=true&lang=scss"

import exportComponent from "D:\\CTS_SURAJ\\City Hoardings\\City_Hoardings_UI\\ui-admin-code\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2c7c3535"]])

export default __exports__